// src/main.ts
import { bootstrapApplication } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from '@env/environment';
import { GaService } from './app/analytics/ga.service';

function disableProdConsole(): void {
  if (!environment.production) return;

  const noop = (): void => {};

  console.log = noop;
  console.info = noop;
  console.debug = noop;

  // Optional: also silence common “debug helper” console methods
  console.group = noop;
  console.groupCollapsed = noop;
  console.groupEnd = noop;
  console.time = noop;
  console.timeEnd = noop;
  console.table = noop;
}

disableProdConsole();

console.log('env:', environment.env, 'static:', environment.useStaticContent);

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {
    const injector = appRef.injector;
    const ga = injector.get(GaService);
    const router = injector.get(Router);
    ga.init(router);
  })
  .catch((err) => console.error(err));
